import { FC, useState, useEffect } from "react";
import { IpropsModalSettings } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import SuccessModalPc from "../modalCommonPc/SuccessModalPc";
const ChoosePaymentPc: FC<IpropsModalSettings> = ({ onClose, open }) => {
  const options = [
    { name: "اتوماتیک", key: 1 }, //0
    { name: "آنلاین", key: 2 }, //1
    { name: "پیامک", key: 3 }, //2
  ];
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [openModalSuccess, setOpenModalSuccess] = useState<boolean>(false);
  useEffect(() => {
    const commType = localStorage.getItem("commandSendType");
    if (commType) {
      setActiveIndex(parseInt(commType));
    }
  }, [open]);

  const openOptions = () => {
    setShowOptions(!showOptions);
  };
  const chooseOption = (index: number) => {
    setShowOptions(false);
    setActiveIndex(index);
  };
  const showOpenModalSuccess = () => {
    setOpenModalSuccess(!openModalSuccess);
  };
  const submit = () => {
    localStorage.setItem("commandSendType", `${activeIndex}`);

    setOpenModalSuccess(true);
    onClose();
  };

  return (
    <>
      <SuccessModalPc
        open={openModalSuccess}
        onClose={showOpenModalSuccess}
        title={"درگاه با موفقیت تغییر یافت"}
      />
      <OverlayModalCommon onClose={onClose} open={open}>
        <div className="contentModalSettingsMapPc scrollbar-div">
          <div className="rowheaderModalSettingMap">
            <div onClick={onClose} className="icon3-close pointer" />
            <div className="titleheaderModal">درگاه ارسال دستور</div>
          </div>
          <div className="rowBodyModalSettingMap">
            <div
              onClick={openOptions}
              className="containerInpuSettingsMap pointer"
            >
              <div className="lableAbsoluteOption">نام درگاه</div>
              <div className="inpTitleSettingMap">
                {options[activeIndex].name}
              </div>
              <div className="icon3-chevron-down" />
            </div>
            {showOptions ? (
              <div className="containerOptionsAbsolute pointer scrollbar-div">
                {options.map((op, index) => (
                  <div
                    onClick={() => chooseOption(index)}
                    className={
                      index === activeIndex
                        ? "optionsContentDiff"
                        : "optionsContent"
                    }
                    key={op.key}
                  >
                    <div className="optionsTitle">{op.name}</div>
                  </div>
                ))}
              </div>
            ) : null}
          </div>

          <div className="rowBtnSettingsMap">
            <div onClick={submit} className="BtnSettingsMapSubmit pointer">
              انتخاب
            </div>
            <div onClick={onClose} className="BtnSettingsMapCancel pointer">
              انصراف
            </div>
          </div>
        </div>
      </OverlayModalCommon>
    </>
  );
};
export default ChoosePaymentPc;
